import { PoprestrictionvdComponent } from './../../main/dashboard/poprestrictionvd/poprestrictionvd.component';
import { PopupRestrictionComponent } from './../../main/dashboard/popup-restriction/popup-restriction.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from 'app/auth/service';
import { ToastrService } from 'ngx-toastr';
import { PayService } from 'app/service/pay.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  exPath = ['/pages/consommation','/pages/historique','/pages/faq','/pages/carterecharge','/pages/transfertdirect','/pages/paiement-marchand',
'/pages/account-settings','/pages/fidelisation','/pages/divertissements','/pages/notifications','cartebancaire']
  constructor(private _router: Router, private _authenticationService: AuthenticationService,
    private toastr: ToastrService,  private modalService: NgbModal, private pay : PayService) {}

  // canActivate
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this._authenticationService.currentUserValue;

    if (currentUser) {
      
      if (this.pay.getPay()){
        return false;
      }
      if (route.data.roles && (currentUser.Enable != 'Actif' || currentUser.smsValidation != 'v')) {
        this.modalService.open(PopupRestrictionComponent, { centered: true });
        return false;
      }else if (route.data.roles && !this.exPath.includes(state.url) && currentUser.typeVerification != 'd') {
        this.modalService.open(PoprestrictionvdComponent, { centered: true });
        return false;
      }
      return true;
    }

    this._router.navigate(['/auth/login']);
    return false;
  }

}
